// Central content for Global-Elect Aviation Services

export const COMPANY = {
  name: "Global-Elect Aviation Services",
  parent: "Global-Elect Management Company",
  parentShort: "G-EMC",
  tagline: "Elevating aviation safety, operations & AI readiness — worldwide.",
  website: "www.globalelectaviation.com",
};

export const CONTACT = {
  phone: "+1 936 233 8831",
  tollFree: "+1 888 217 7519",
  mobile: "+1 346 532 8665",
  eFax: "+1 936 233 8748",
  email: "info@globalelectcompany.com",
  sales: "sales@globalelectaviation.com",
  address: "2503 Lake Road, Suite C102, Huntsville, TX 77340, USA",
};

export const IMAGES = {
  heroJet:
    "https://images.unsplash.com/photo-1474302770737-173ee21bab63?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NDk1Nzd8MHwxfHNlYXJjaHwxfHxwcmVtaXVtJTIwcHJpdmF0ZSUyMGpldCUyMHJ1bndheSUyMHN1bnNldHxlbnwwfHx8fDE3ODM4OTQ3ODh8MA&ixlib=rb-4.1.0&q=85",
  cockpit:
    "https://images.unsplash.com/photo-1713327023739-fb362e20b96b?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjY2NzZ8MHwxfHNlYXJjaHw0fHxhdmlhdGlvbiUyMHNhZmV0eSUyMGluc3BlY3RvciUyMHByb2Zlc3Npb25hbHxlbnwwfHx8fDE3ODM4OTQ3ODh8MA&ixlib=rb-4.1.0&q=85",
  africa:
    "https://images.unsplash.com/photo-1665341909795-328137e8cc18?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NDk1ODB8MHwxfHNlYXJjaHwyfHxhZnJpY2ElMjBsYW5kc2NhcGUlMjBmcm9tJTIwYWlycGxhbmV8ZW58MHx8fHwxNzgzODk0Nzg4fDA&ixlib=rb-4.1.0&q=85",
  airport:
    "https://images.unsplash.com/photo-1687552626877-f4596995931c?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjAzMzl8MHwxfHNlYXJjaHwyfHxtb2Rlcm4lMjBhaXJwb3J0JTIwdGVybWluYWwlMjBhcmNoaXRlY3R1cmV8ZW58MHx8fHwxNzgzODk0Nzg4fDA&ixlib=rb-4.1.0&q=85",
  ai:
    "https://images.unsplash.com/photo-1674027444485-cec3da58eef4?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjA1ODh8MHwxfHNlYXJjaHwzfHxBSSUyMHRlY2hub2xvZ3klMjBnbG9iYWwlMjBuZXR3b3JrfGVufDB8fHx8MTc4Mzg5NDc4OHww&ixlib=rb-4.1.0&q=85",
  consulting:
    "https://images.unsplash.com/photo-1573164574572-cb89e39749b4?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NTY2Njl8MHwxfHNlYXJjaHwzfHxidXNpbmVzcyUyMHByb2Zlc3Npb25hbHMlMjBtZWV0aW5nfGVufDB8fHx8MTc4Mzg5NDc4OHww&ixlib=rb-4.1.0&q=85",
  tower:
    "https://images.unsplash.com/photo-1677924656040-703debadc2f8?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjA1MDZ8MHwxfHNlYXJjaHwzfHxhaXJwb3J0JTIwY29udHJvbCUyMHRvd2VyJTIwYXJjaGl0ZWN0dXJlfGVufDB8fHx8MTc4Mzg5NDg1Mnww&ixlib=rb-4.1.0&q=85",
  jetTarmac:
    "https://images.unsplash.com/photo-1635672033263-a19f27eaefa8?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjA1ODR8MHwxfHNlYXJjaHwzfHxwcml2YXRlJTIwamV0JTIwbHV4dXJ5JTIwdGFybWFjfGVufDB8fHx8MTc4Mzg5NDg1Mnww&ixlib=rb-4.1.0&q=85",
};

export const SERVICES = [
  {
    slug: "safety-compliance-review",
    icon: "ShieldCheck",
    title: "Aviation Safety & Compliance Review",
    tagline: "Assess, strengthen and certify your safety and compliance systems.",
    summary:
      "Independent review of your safety and compliance posture — from gap analysis to audit readiness — so your organization is inspection-ready and resilient.",
    features: [
      "Compliance gap analysis",
      "Audit readiness reviews",
      "Safety Management System (SMS) assessment",
      "Internal process review",
      "Risk & control recommendations",
    ],
    image: "cockpit",
  },
  {
    slug: "operations-improvement",
    icon: "TrendingUp",
    title: "Aviation Operations Improvement Advisory",
    tagline: "Sharpen efficiency, process quality and operational performance.",
    summary:
      "We help operators standardize processes, remove friction and lift operational performance without compromising safety or compliance.",
    features: [
      "SOP review and improvement",
      "Workflow optimization",
      "Operations performance assessment",
      "Process standardization support",
      "Operational risk reduction recommendations",
    ],
    image: "jetTarmac",
  },
  {
    slug: "ai-readiness",
    icon: "Cpu",
    title: "AI Readiness for Aviation Organizations",
    tagline: "Adopt AI safely, responsibly and with measurable impact.",
    summary:
      "A strategic advisory service that prepares aviation organizations to deploy AI where it matters — with governance, guardrails and real operational use-cases.",
    features: [
      "AI readiness assessment",
      "AI adoption strategy",
      "Workflow automation planning",
      "AI governance & policy guidance",
      "Operational & compliance use-case identification",
    ],
    image: "ai",
  },
  {
    slug: "security-risk-assessment",
    icon: "ShieldAlert",
    title: "Aviation Security Risk Assessment",
    tagline: "Review and strengthen your security posture and procedures.",
    summary:
      "Structured evaluation of vulnerabilities, frameworks and procedures to reduce organizational risk and harden your aviation security posture.",
    features: [
      "Security assessments",
      "Vulnerability reviews",
      "Framework & policy evaluation",
      "Procedural improvement recommendations",
      "Organizational risk review",
    ],
    image: "tower",
  },
  {
    slug: "government-documentation",
    icon: "Landmark",
    title: "Government Capability & Aviation Documentation Support",
    tagline: "Public-sector readiness plus the documentation that wins trust.",
    summary:
      "A combined service line covering government-facing positioning and the critical documentation aviation organizations depend on — from capability statements to manuals.",
    features: [
      "Capability statement development",
      "Proposal & readiness support",
      "Contract opportunity positioning",
      "SOP / manual development",
      "Compliance documentation support",
      "Safety & security manual support",
    ],
    image: "airport",
  },
];

export const SECONDARY_SERVICES = [
  {
    icon: "GraduationCap",
    title: "Aviation Training Advisory",
    summary:
      "Advisory support for training organizations building curricula, standards and instructor competency frameworks. Available now as a secondary service line.",
  },
];

export const INDUSTRIES = [
  { icon: "Plane", title: "Airlines", desc: "Scheduled carriers strengthening safety, compliance and operational performance." },
  { icon: "Navigation", title: "Charter Operators", desc: "On-demand and fractional operators optimizing SOPs and risk controls." },
  { icon: "Gem", title: "Private Aviation", desc: "Owners and management companies elevating standards and governance." },
  { icon: "Building2", title: "Airport Service Organizations", desc: "Ground, FBO and airport service providers improving procedures." },
  { icon: "Wrench", title: "MRO & Maintenance", desc: "Maintenance and repair organizations preparing for audits and scale." },
  { icon: "Rocket", title: "Aviation Startups", desc: "Emerging operators building compliant foundations from day one." },
  { icon: "GraduationCap", title: "Training Organizations", desc: "ATOs and academies raising instructional and safety standards." },
  { icon: "Landmark", title: "Government & Public-Sector", desc: "Civil aviation bodies and agencies advancing capability and readiness." },
];

export const WHY_CHOOSE = [
  {
    icon: "Globe2",
    title: "Global perspective, local precision",
    desc: "We operate with a worldwide lens while tailoring recommendations to your regulatory environment and market realities.",
  },
  {
    icon: "ShieldCheck",
    title: "Safety & compliance first",
    desc: "Every engagement is grounded in airworthy standards — we strengthen your posture without slowing you down.",
  },
  {
    icon: "Cpu",
    title: "Future-facing AI expertise",
    desc: "We help aviation organizations adopt AI responsibly, with governance and real operational value.",
  },
  {
    icon: "Landmark",
    title: "Public & private credibility",
    desc: "Trusted across commercial operators and government-related aviation bodies, including U.S. capability positioning.",
  },
];

export const STATS = [
  { value: "5", label: "Core advisory service lines" },
  { value: "Global", label: "Commercial & public-sector reach" },
  { value: "Africa", label: "Dedicated growth focus" },
  { value: "AI", label: "Future-ready transformation" },
];

export const ORG_TYPES = [
  "Airline",
  "Charter Operator",
  "Private Aviation Company",
  "Airport Service Organization",
  "MRO / Maintenance Organization",
  "Aviation Startup",
  "Training Organization",
  "Government / Public-Sector Body",
  "Other",
];

export const REGIONS = [
  "North America",
  "Africa",
  "Europe",
  "Middle East",
  "Asia-Pacific",
  "Latin America",
  "Global / Multi-region",
];

export const BLOG = [
  {
    slug: "africa-aviation-growth-decade",
    title: "Why the Next Decade of Aviation Growth Runs Through Africa",
    category: "Market Insight",
    date: "June 2, 2026",
    readTime: "6 min read",
    excerpt:
      "Africa's aviation market is entering a structural growth phase. Here is where operators, investors and regulators should focus to capture it safely.",
    image: "africa",
    body: [
      "Africa is one of the fastest-growing aviation regions in the world. Rising middle-class demand, liberalization efforts such as the Single African Air Transport Market (SAATM), and infrastructure investment are converging to create a decade of structural opportunity.",
      "But growth without governance is fragile. Operators expanding into new routes must simultaneously invest in safety management systems, compliance frameworks and workforce competency. The organizations that win will treat safety and operational maturity as a growth enabler, not a cost center.",
      "At Global-Elect Aviation Services, we help operators and public-sector bodies position for this growth — pairing operational improvement with the compliance and documentation foundations that unlock partnerships, financing and cross-border expansion.",
      "The takeaway is simple: the runway for African aviation growth is long, but it rewards those who build on solid, auditable foundations.",
    ],
  },
  {
    slug: "ai-readiness-aviation-2026",
    title: "AI Readiness in Aviation: A Practical Framework for 2026",
    category: "AI Transformation",
    date: "May 20, 2026",
    readTime: "7 min read",
    excerpt:
      "AI adoption in aviation is accelerating. A disciplined readiness framework separates real value from expensive experiments.",
    image: "ai",
    body: [
      "Every aviation organization now faces pressure to 'do something with AI.' The risk is chasing tools before establishing readiness — the data, governance and use-case discipline that make AI safe and valuable.",
      "Our readiness framework starts with three questions: Where does AI create measurable operational value? What governance and policy guardrails must exist first? And which workflows are mature enough to automate responsibly?",
      "High-value early use-cases typically cluster around documentation, compliance monitoring, predictive maintenance signals and operational decision support — areas where AI augments experts rather than replacing accountability.",
      "The organizations that succeed treat AI as a governed capability, not a gadget. Readiness first, deployment second.",
    ],
  },
  {
    slug: "audit-readiness-that-lasts",
    title: "Building Audit Readiness That Lasts Beyond the Inspection",
    category: "Safety & Compliance",
    date: "May 6, 2026",
    readTime: "5 min read",
    excerpt:
      "Passing an audit is a milestone, not a finish line. Here is how to build compliance systems that stay ready year-round.",
    image: "cockpit",
    body: [
      "Too many organizations treat audit readiness as a fire drill — a scramble of documentation and last-minute fixes. The result is stress, findings and rework.",
      "Sustainable readiness comes from embedding compliance into daily operations: living SOPs, a functioning safety management system, and clear ownership of risks and controls.",
      "Our Safety & Compliance Review identifies the gaps between your written system and your actual practice, then builds the process discipline that keeps you inspection-ready every day of the year.",
      "When compliance is operationalized, audits stop being events to survive and become confirmations of what you already do well.",
    ],
  },
];

export const AI_ICONS = {
  auditguard: "https://static.prod-images.emergentagent.com/jobs/de83c9c6-5a60-47de-85ab-59250e6cb264/images/e7f0cc154f0f1b706faf805688e1c6493d262a38843a162cb6f6d7991ad7f07f.png",
  compliance: "https://static.prod-images.emergentagent.com/jobs/de83c9c6-5a60-47de-85ab-59250e6cb264/images/379e11773fc1c9d4f1690d8f3a0addba1fc16ead062629d98a7bff3b62eca8b0.png",
  safety: "https://static.prod-images.emergentagent.com/jobs/de83c9c6-5a60-47de-85ab-59250e6cb264/images/10c42c29b43722b708d5827db1b83e88cbbd587ee69461527d7f813a14f04637.png",
  operations: "https://static.prod-images.emergentagent.com/jobs/de83c9c6-5a60-47de-85ab-59250e6cb264/images/e60a465c482a3b4d3858de8bed5a505c1d58aa013a4e00249763328544bcfe66.png",
  training: "https://static.prod-images.emergentagent.com/jobs/de83c9c6-5a60-47de-85ab-59250e6cb264/images/0dfcd3269971156b2375443b3221fd6edb7f267d220966e162c8b2164daaf53e.png",
  documents: "https://static.prod-images.emergentagent.com/jobs/de83c9c6-5a60-47de-85ab-59250e6cb264/images/f7b46f43937482274725cb9bd8bef20fed040a6bcaf8f091d287b1acc78e370b.png",
  portal: "https://static.prod-images.emergentagent.com/jobs/de83c9c6-5a60-47de-85ab-59250e6cb264/images/f17e98a47025513144d2482aea68f6d07a5147411fee7ba0cee4cac19e302de6.png",
  api: "https://static.prod-images.emergentagent.com/jobs/de83c9c6-5a60-47de-85ab-59250e6cb264/images/ef939bb1fd313508cd1f7addec2b92d6c720f14ce4046dc57c3705e94bf0d333.png",
};

export const AUDITGUARD = {
  name: "AuditGuard AI",
  tagline: "Flagship Aviation Compliance Platform",
  intro:
    "The centerpiece of our technology division — an intelligent platform that automates audit preparation, compliance documentation, safety analysis and operational oversight.",
  components: [
    { label: "AI Audit Preparation Assistant", icon: "ClipboardCheck" },
    { label: "AI Safety Report Analyzer", icon: "FileSearch" },
    { label: "AI Compliance Document Generator", icon: "FileText" },
    { label: "AI Corrective Action Plan Builder", icon: "Wrench" },
    { label: "AI Gap Analysis Engine", icon: "GitCompare" },
    { label: "AI Risk Prediction Model", icon: "BarChart3" },
    { label: "AI Training & Competency Coach", icon: "GraduationCap" },
  ],
  servesTitle: "Built for",
  serves: [
    "Flight schools",
    "Charter operators",
    "Airports",
    "MROs",
    "Drone / UAS companies",
    "Regional airlines",
  ],
};

export const AI_SOLUTIONS = [
  {
    icon: "Scale",
    img: AI_ICONS.compliance,
    title: "AI-Powered Aviation Compliance",
    summary: "Automatically interprets regulatory requirements and produces checklists, gap analysis reports, corrective actions and audit-ready documentation.",
    tools: [
      "AI ICAO Compliance Mapping",
      "AI FAA Part 5 SMS Support",
      "AI EASA Compliance Alignment",
      "AI IS-BAO Audit Support",
      "AI IOSA / ISAGO Gap Analysis",
      "AI CAA Regulatory Monitoring",
    ],
  },
  {
    icon: "TriangleAlert",
    img: AI_ICONS.safety,
    title: "AI Safety & Risk Management",
    summary: "Transforms raw safety data into risk scores, trend analysis, performance dashboards and automated recommendations.",
    tools: [
      "AI Hazard Identification Engine",
      "AI Risk Assessment Scoring",
      "AI Safety Report Classification",
      "AI Trend & Pattern Detection",
      "AI Safety Performance Indicator Monitoring",
    ],
  },
  {
    icon: "Workflow",
    img: AI_ICONS.operations,
    title: "AI Operational Oversight",
    summary: "Improves operational efficiency by analyzing SOPs, workflows, operational risks and quality assurance processes.",
    tools: [
      "AI SOP Review & Optimization",
      "AI Workflow Automation for Operations",
      "AI Quality Management Support",
      "AI Operational Risk Alerts",
    ],
  },
  {
    icon: "GraduationCap",
    img: AI_ICONS.training,
    title: "AI Training & Competency",
    summary: "Helps organizations maintain competency standards, training compliance and qualification tracking.",
    tools: [
      "AI Competency Gap Detection",
      "AI Training Needs Analysis",
      "AI Course Recommendation Engine",
      "AI Training Records Review",
    ],
  },
  {
    icon: "FileText",
    img: AI_ICONS.documents,
    title: "AI Document Automation",
    summary: "Creates aviation documents in minutes instead of weeks — from manuals to corrective action plans.",
    tools: [
      "AI Policy & Manual Generator",
      "AI SOP Drafting Assistant",
      "AI Audit Checklist Builder",
      "AI Corrective Action Documentation",
    ],
  },
  {
    icon: "LayoutDashboard",
    title: "AI Client Portal",
    summary: "A secure client workspace to track engagements, compliance status and documentation in one place.",
    tools: [
      "Secure login",
      "Audit history",
      "Compliance dashboards",
      "Document storage",
      "Team collaboration tools",
    ],
  },
  {
    icon: "Server",
    img: AI_ICONS.api,
    title: "AI API Layer",
    summary: "The backend layer that lets our platform and website communicate with every AI system securely.",
    tools: [
      "AuditGuard AI API",
      "Client portal API",
      "Compliance data API",
      "Document generation API",
    ],
  },
];


export const TEAM = {
  leader: {
    name: "Dr. Lewis B. Bessong",
    title: "Founder & Principal Consultant",
    initials: "LB",
    photo: "https://customer-assets-lqy194kg.emergentagent.net/job_global-aviation-hub-1/artifacts/fw267msa_PROFILE.jpg",
    bio: [
      "Dr. Lewis B. Bessong is the Founder and Principal Consultant of Global-Elect Aviation Services, the aviation division of Global-Elect Management Company (G-EMC). He leads the firm with a strategic focus on strengthening operational performance, enhancing regulatory compliance, and integrating advanced technology to support the evolving needs of the aviation industry.",
      "He brings extensive experience supporting airlines, charter operators, training organizations and government-facing entities — specializing in compliance alignment, operational documentation, SOP development, safety programs and audit readiness. His work is grounded in precision, accountability and a commitment to operational excellence.",
      "Under his leadership, Global-Elect Aviation Services has expanded its capabilities to include AI-enabled compliance solutions — most notably AuditGuard AI, an intelligent platform designed to automate document analysis, streamline audit preparation and enhance regulatory readiness. This integration of established aviation expertise with modern technology positions G-EMC as a forward-thinking leader in the aviation consulting sector.",
      "Dr. Bessong remains dedicated to advancing safety, compliance and operational integrity across the aviation industry, guiding organizations through both established regulatory requirements and emerging technological opportunities.",
    ],
    credentials: [
      "Doctorate in Management",
      "M.Sc., Aviation Security",
      "M.Sc., Aviation Operations Management",
      "M.Sc., Aviation Business Management",
      "B.Sc., Aviation Technology",
      "Diploma, Accounting & Finance",
    ],
  },
  advisors: [
    { icon: "ShieldCheck", role: "Safety & Compliance Lead", focus: "SMS assessments, audit readiness and regulatory alignment." },
    { icon: "TrendingUp", role: "Operations Advisor", focus: "SOP standardization, workflow optimization and performance." },
    { icon: "Cpu", role: "AI Strategy Lead", focus: "Responsible AI adoption, governance and automation planning." },
    { icon: "ShieldAlert", role: "Aviation Security Lead", focus: "Security posture reviews, vulnerability and framework evaluation." },
    { icon: "Landmark", role: "Documentation & Capability Lead", focus: "Capability statements, manuals and public-sector readiness." },
  ],
  networkNote:
    "Our leadership is supported by a trusted network of aviation specialists — safety inspectors, operations experts, security professionals and AI strategists — engaged as each engagement requires.",
  ceoMessage:
    "Aviation runs on trust — in our safety systems, our processes and, increasingly, our technology. At Global-Elect Aviation Services we exist to strengthen that trust: helping organizations operate safely, prepare confidently for audits and the public sector, and adopt AI responsibly. Wherever you operate — and with a special commitment to the growth ahead across Africa — our team is ready to help you rise to the standard the industry demands.",
};


export const NAV_LINKS = [
  { label: "About", to: "/about" },
  { label: "Team", to: "/team" },
  { label: "Services", to: "/services" },
  { label: "AI Solutions", to: "/ai-solutions" },
  { label: "Industries", to: "/industries" },
  { label: "Government", to: "/government" },
  { label: "Africa", to: "/africa" },
  { label: "Insights", to: "/insights" },
  { label: "Contact", to: "/contact" },
];
